"use strict";

var config = {};
try {
  // eslint-disable-next-line global-require
  config = require('lc-app-config');
} catch (e) {
  // could not load properly, set up an empty module instead
} finally {
  if (!config.get) {
    config = {
      get: function get() {
        return null;
      }
    };
  }
}
function helper(Handlebars) {
  var scriptUrl = config.get('TC_ELASTIC_APM_RUM_SERVER_URL') || 'https://static-internal.lendingcloud.us/www/src/hosted/scripts/';
  var scriptFile = config.get('TC_DMR_DEFINE_MODULE_FILENAME') || 'dynamic-module-registry-browser-set.js';
  var scriptClass = 'dmr-set';
  function defineModule(key, options) {
    var outputValue = encodeURIComponent(options.fn(this).trim()).replace(/[!'()*]/g, function (c) {
      return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
    });
    var encoder = 'alternative';
    var str = "<script class='".concat(scriptClass, "' key='").concat(key, "' encoder=").concat(encoder, " outputValue='").concat(outputValue, "' type='text/javascript' src='").concat(scriptUrl).concat(scriptFile, "'> </script>");
    return new Handlebars.SafeString(str);
  }
  Handlebars.registerHelper('defineModule', defineModule);
  return defineModule;
}
module.exports = helper;
